import classNames from 'classnames';
import React from 'react';
import { buildStyles, CircularProgressbarWithChildren } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

interface Props {
	value: number;
	showLarge?: boolean;
}

const MatchPercentageCircularBarComponent = ({ value, showLarge }: Props) => {
	return (
		<CircularProgressbarWithChildren
			styles={buildStyles({
				pathColor: value < 30 ? '#FF5C5C' : value < 70 ? '#FDAC42' : '#39D98A',
				trailColor: '#555770',
				strokeLinecap: 'round',
				pathTransitionDuration: 1,
				rotation: 0.726,
			})}
			strokeWidth={showLarge ? 13 : 11}
			circleRatio={0.55}
			value={value}
		>
			<div className="text-center mt-1">
				<div
					className={classNames('text-[12px] font-[600] text-[#28293D] dark:text-white leading-3', {
						'text-[12px] md:text-[16px]': showLarge,
					})}
				>
					{value}%
				</div>
				<div
					className={classNames('text-[8px] font-[500] text-[#8F90A6] dark:text-[#CDF] leading-3', {
						'text-[8px] md:!text-[12px] pt-1': showLarge,
					})}
				>
					Match
				</div>
			</div>
		</CircularProgressbarWithChildren>
	);
};

export default MatchPercentageCircularBarComponent;
